<div class="status-box">
  <div class="status-container">
    <div class="image-box">
      <img
        src="{{ 'assets/img/Close-Circle.png' | xeaSourcePath }}"
        class="status-image"
      />
    </div>
    <div class="message-box">
      <div class="status-title">{{ notFoundTitle | translate }}</div>
      <div class="status-message">
        {{ notFoundUrlMsg | translate: { notFoundUrl: notFoundUrl } }}
      </div>
    </div>
  </div>
</div>
